import { atom } from 'recoil'
import { IProjectCheckpointArtifact } from './projectCheckpoints.types'

interface ICheckpointArtifactsAtom {
  /**
   * Map of checkpoints ids and their criteria
   */
  items: Record<string, IProjectCheckpointArtifact[]>
}

const checkpointsArtifactsAtom = atom<ICheckpointArtifactsAtom>({
  key: 'project-checkpoints/artifacts',
  default: { items: {} },
})
export default checkpointsArtifactsAtom
